import LayoutContainer from '@shared/components/Layout/LayoutContainer';
import useMsalUser from '@shared/hooks/useMsalUser';
import { useEffect } from 'react';

import PageLoader from './PageLoading';

export default function LogoutHandler() {
    const { signOut } = useMsalUser();

    useEffect(() => {
        signOut(false);
    }, [signOut]);

    return (
        <LayoutContainer includeFooter={true}>
            <PageLoader label="about-loading" />
        </LayoutContainer>
    );
}
